import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';

const pdsModalHeaderCss = "pds-modal-header{display:block;width:100%}.pds-modal__header{width:100%}";

const PdsModalHeader$1 = /*@__PURE__*/ proxyCustomElement(class PdsModalHeader extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
    }
    render() {
        return (h("header", { key: 'c832013aee204170c29336e931d36f1eda667f11', class: "pds-modal__header" }, h("slot", { key: '19a76b689a8d8bf116f7061fd7c32415da4299e1' })));
    }
    static get style() { return pdsModalHeaderCss; }
}, [4, "pds-modal-header"]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["pds-modal-header"];
    components.forEach(tagName => { switch (tagName) {
        case "pds-modal-header":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, PdsModalHeader$1);
            }
            break;
    } });
}

const PdsModalHeader = PdsModalHeader$1;
const defineCustomElement = defineCustomElement$1;

export { PdsModalHeader, defineCustomElement };
//# sourceMappingURL=pds-modal-header.js.map

//# sourceMappingURL=pds-modal-header.js.map